export default {
  SEARCH_CATALOG_ALLIANZ_RESOURCE_ORIGIN_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_RESOURCE_ORIGIN_QUERY'),
  CATALOG_ALLIANZ_RESOURCE_ORIGIN_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_RESOURCE_ORIGIN_REPOSITORY'),
  CATALOG_ALLIANZ_RESOURCE_ORIGIN_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_RESOURCE_ORIGIN_STATE_MANAGER'),
};
